<template>
    <BlogPage
      :blogHeaderTitle="blogHeaderTitle"
      :blogItems="blogItems"
    />
  </template>
  
  <script>
    import moment from 'moment';
    import BlogPage from './blogPage.vue';
  
    export default {
      data(){
        return {
          blogHeaderTitle: 'Cyber Corner Blogs Archives',
          blogItems: [],
        };
      },
      props: {
        query: String,
        blogPage: String,
      },
      components: {
        BlogPage,
      },
      mounted(){
        this.getBlogPosts();
      },
      methods: {
        getBlogPosts() {
          const _blogItems = this.$store.state.blogItems;
          const fromTheLastSixMonths = moment().subtract(6, 'months').valueOf();
          // THIS RETRIEVES THE BLOGS OLDER THAN THE LAST SIX MONTHS
          this.blogItems = _blogItems.filter(({ date }) => moment(date).valueOf() < fromTheLastSixMonths);
        },
      }
    }
  </script>